import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "className"];
import React from 'react';
import { Breadcrumbs } from '@gravity-ui/uikit';
import { escapeHighlight } from '../../utils';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { Row } from './Row';
import './WikiRow.css';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('search-wiki-row');
var delimeter = function delimeter() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: "\u203A"
  });
};
var crumbHighlighter = function crumbHighlighter(item) {
  return /*#__PURE__*/_jsx(Highlight, {
    text: item.rawText
  });
};
export function WikiRow(_ref) {
  var item = _ref.item,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var breadcrumbs = React.useMemo(function () {
    var _item$breadcrumbs$map, _item$breadcrumbs;
    return (_item$breadcrumbs$map = (_item$breadcrumbs = item.breadcrumbs) === null || _item$breadcrumbs === void 0 ? void 0 : _item$breadcrumbs.map(function (_ref2) {
      var name = _ref2.name;
      return {
        text: escapeHighlight(name),
        rawText: name
      };
    })) !== null && _item$breadcrumbs$map !== void 0 ? _item$breadcrumbs$map : [];
  }, [item]);
  var description = /*#__PURE__*/_jsx(Breadcrumbs, {
    items: breadcrumbs,
    className: b('breadcrumbs'),
    renderItemDivider: delimeter,
    firstDisplayedItemsCount: 1,
    lastDisplayedItemsCount: 1,
    renderRootContent: crumbHighlighter,
    renderItemContent: crumbHighlighter
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    description: description,
    className: b(null, className),
    item: item
  }, otherProps));
}
// #sourceMappingURL=WikiRow.js.map